import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SideBar from "../../../components/b2b/SideBar";
import VehiclePriceCard from "../../../components/b2c/VehiclePriceCard";
import Header from "../../../components/landingPage/Header";
import LoadingSkeleton from "../../../components/loading/LoadingSkeleton";
import searchingImage from "../../../assets/images/searching.svg";
import SearchResultHeading from "../../../components/b2c/SearchResultHeading";
import { ArrowCircleLeftIcon } from "@heroicons/react/solid";
import { Link, useNavigate } from "react-router-dom";
import {
  getVehicle,
  getVehicles,
} from "../../../redux/app/vehicle/vehicle-slice";
import axios from "axios";
import {
  setConvertedPrice,
  setCurrencyPrice,
  setSearchResultScreen,
  setisSearchingprice,
} from "../../../redux/app/booking/booking-slice";

import { UserIcon, BriefcaseIcon } from "@heroicons/react/solid";
import InfoCard from "../../../components/b2c/InfoCard";
import {
  faHourglassEnd,
  faClock,
  faCheckCircle,
  faPlane,
} from "@fortawesome/fontawesome-free-solid";
import LoadingIcon from "../../../components/loading/LoadingIcon";
// import { useSelector } from "react-redux";
import moment from "moment";
import momenttz from "moment-timezone";

function FlatRateSearchResult() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token, user } = useSelector((state) => state.auth);
  const { vehicles, err, distance, duration } = useSelector(
    (state) => state.vehicle
  );
  const { companyPermission } = useSelector((state) => state.company);
  const {
    booking,
    // distance,
    timezone,
    selectdCurrency,
    convertedPrice,
    checkSourceRegion,
    checkDestinationRegion,
    bookingDuration,
    searchResultScreen,
    isSearchingPrice,
    currencyprice,
    dateChange,
    bookingInitiateLoading,
    dateTimeIST,
  } = useSelector((state) => state.booking);
  const { sourceInputFromApi, destinationInputFromApi } = useSelector(
    (state) => state.map
  );

  const handleBooking = async (vehicle) => {
    let travelTimeStampObj = new Date(
      booking.travelDate + " " + booking?.travelTime?.split(" ")[1]
    );
    //
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/places/placeTimezone?lat=${booking?.source?.lat}&lng=${booking?.source?.lng}`
    );

    let travelDate = moment(booking.travelDate).format("YYYY-MM-DD");

    let travelTime = booking.travelTime.split(" ")[1];

    const dateTime = momenttz.tz(
      `${travelDate} ${travelTime}`,
      response?.data?.timezone
    );

    const formattedTimestamp = dateTime.format();

    console.log("booking.source===>", booking.source);
    console.log("vehicle?.price", vehicle?.price);

    const payload = {
      source: booking.source,
      destination: booking.destination,
      travelDate: booking.travelDate,
      travelTime: booking.travelTime.split(" ")[1],
      travelTimeStamp: formattedTimestamp,
      passenger: booking.passenger,
      bookingType: booking.bookingType,
      travelDistance: distance,
      priceDetails: {
        amount: currencyprice[vehicle?.vehicleName][selectdCurrency],
        currency: selectdCurrency,
      },
      bookingPriceInUsd: vehicle?.price[selectdCurrency],
      duration: bookingDuration,
      timeZone: timezone,
      vehicle: {
        vehicleName: vehicle?.vehicleName,
      },
      userName:
        user?.userName +
        ` ${
          companyPermission?.flatRateBooking?.MeetAndGreet === "WITHOUT"
            ? "(Flatrate w m&G)"
            : "(Flatrate)"
        } `,
      user: user?._id,
      indianTravelDate: moment(dateTimeIST?.converted_time).format(),
      indianTravelTime: moment(dateTimeIST?.converted_time).format("HH:mm"),
    };

    dispatch({
      type: "BOOKING_INITIATE_WITH_VEHICLE",
      payload: {
        payload,
        navigate,
        flatrate: true,
      },
    });
    dispatch(
      getVehicle({
        vehicle,
      })
    );
  };

  useEffect(() => {
    if (vehicles === undefined) {
      if (checkDestinationRegion && checkSourceRegion && dateChange) {
        dispatch({
          type: "SEARCH_INITIATE",
        });
      }
    }
  }, [
    vehicles,
    checkDestinationRegion,
    checkSourceRegion,
    dateChange,
    dispatch,
  ]);

  useEffect(() => {
    if (isSearchingPrice) {
      dispatch({
        type: "GET_VEHICLE_UNIT_PRICE",
        payload: {
          currency: selectdCurrency,
          vehicleWithPricevalue: JSON.stringify(currencyprice),
        },
      });
      dispatch(
        setisSearchingprice({
          isSearchingPrice: false,
        })
      );
    }
  }, [isSearchingPrice]);

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
      // window.location.pathname = "/newbooking";
    };
  }, []);

  const alertUser = (e) => {
    e.preventDefault();
    e.returnValue = "";
    localStorage.setItem("relodePage", "true");
  };

  useEffect(() => {
    if (localStorage.getItem("relodePage")) {
      localStorage.removeItem("relodePage");
      navigate("/flatrates");
    }
  }, [navigate]);

  console.log(currencyprice, "currencyprice<===>");

  return (
    <div className="h-screen w-screen fixed">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className="w-screen">
          <div className="md:space-x-2 lg:space-x-5 mx-3 md:mx-5">
            <div className="w-min">
              <Link to="/flatrates">
                <ArrowCircleLeftIcon className="w-8 text-gray-600 mt-3" />
              </Link>
            </div>
            <div className="">
              <SearchResultHeading
                b2b={true}
                flatrate={true}
                searchCompleted={true}
                chVehicleCurrent={true}
                showBookingDetail={true}
              />
            </div>
          </div>
          <div className="h-[70vh] overflow-y-auto scrollbar">
            <div className="lg:inline lg:overflow-y-auto pb-16">
              {vehicles === undefined && err === undefined && (
                <div className="space-y-4 my-2">
                  <LoadingSkeleton />
                  <LoadingSkeleton />
                  <LoadingSkeleton />
                </div>
              )}
              {vehicles === undefined && err !== undefined && (
                <>
                  <div className="my-12 mx-auto  text-center text-primary text-2xl font-semibold">
                    <div className="flex space-x-4 items-center justify-center">
                      <div>{err}</div>
                      <Link to="/newbooking">
                        <div
                          onClick={() => {
                            // setopenDrawer(true);
                          }}
                          className="bg-primary hover:bg-red-700 cursor-pointer hover:shadow-md text-center text-lg text-white px-3 py-2 rounded-sm "
                        >
                          Search again
                        </div>
                      </Link>
                    </div>

                    <img
                      src={searchingImage}
                      alt=""
                      className="w-80 block mx-auto my-9"
                    />
                  </div>
                </>
              )}

              {vehicles?.length === 0 && (
                <>
                  <div className="my-12 mx-auto  text-center text-primary text-2xl font-semibold">
                    <div className="flex space-x-4 items-center justify-center">
                      <div>No vehicles found</div>
                      <Link to="/newbooking"></Link>
                    </div>
                  </div>
                </>
              )}

              {vehicles !== undefined &&
                vehicles?.map((vehicle) => (
                  <div className="my-12">
                    {vehicle?.passengeCount >=
                      booking?.passenger.split("")[0] && (
                      <VehiclePriceCardFlat
                        b2b={true}
                        key={vehicle._id}
                        vehicleName={vehicle?.vehicleType}
                        passengers={vehicle?.passengeCount}
                        luggages={vehicle?.luggageCount}
                        description={vehicle?.description}
                        image={vehicle?.image}
                        // price={vehicle.price}
                        price={
                          currencyprice &&
                          currencyprice[vehicle?.vehicleName] &&
                          currencyprice[vehicle?.vehicleName][selectdCurrency]
                            ? currencyprice[vehicle?.vehicleName][
                                selectdCurrency
                              ]
                            : "Loading..."
                        }
                        unit={selectdCurrency && selectdCurrency}
                        onClick={() => handleBooking(vehicle)}
                      />
                    )}
                  </div>
                ))}
              {/* <div className="mb-20"></div> */}
              {/* <VehiclePriceCard /> */}
            </div>
            {/* <div className="pb-32"></div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FlatRateSearchResult;

const VehiclePriceCardFlat = ({
  b2b,
  vehicleName,
  passengers,
  luggages,
  description,
  image,
  price,
  unit,
  onClick,
  isOffLine = false,
  priceInputChange,
  priceValue,
}) => {
  const { token, user } = useSelector((state) => state.auth);
  const { selectdCurrency, currencyprice, bookingInitiateLoading } =
    useSelector((state) => state.booking);
  const { companyPermission } = useSelector((state) => state.company);

  return (
    <div className="lg:flex grow justify-between mx-3 md:mx-5 xl:mx-6 border rounded-md shadow-md hover:shadow-lg border-gray-30 md:w-[90%] lg:w-[90%]">
      <div className="sm:w-full lg:w-auto">
        <div className="flex items-center px-4 pt-4 space-x-6">
          {/* vehicle name */}
          <div className="flex space-x-2 items-center">
            <div
              className={`${
                b2b ? "text-xs sm:text-lg lg:text-2xl" : "text-lg lg:text-2xl"
              }   font-semibold font-sans text-black`}
            >
              {vehicleName}
            </div>
            {/* <div
              className={`${
                b2b
                  ? "text-[1rem] sm:text-lg text-lg lg:text-2xl"
                  : "text-lg lg:text-2xl"
              }   font-semibold font-sans text-slate-400 italic`}
            >
              {vehicleName}
            </div> */}
          </div>
          <div className="flex space-x-2">
            {/*  person */}
            <div className="flex items-center space-x-1 ">
              {" "}
              <UserIcon className="w-5 h-5 text-gray-600" />{" "}
              <div className="text-sm">{passengers} Max</div>
            </div>
            {/* luggage */}
            <div className="flex items-center space-x-2">
              {" "}
              <BriefcaseIcon className="w-5 h-5 text-gray-600" />{" "}
              <div className="text-sm">{luggages} Max</div>
            </div>
          </div>
        </div>
        <div className="px-4 text-sm font-normal text-secondary">
          {description}
        </div>
        <div className="px-4 pt-4 mb-3 lg:w-full text-base">
          <InfoCard
            b2b={b2b}
            color="text-orange-700"
            fontawesomeIconName={faCheckCircle}
            infotext={`Free 60 minutes waiting time after flight landing for airport pickups, 15 minutes waiting time for all other pickups. ${
              companyPermission?.flatRateBooking?.MeetAndGreet === "WITHOUT"
                ? "(Meet and Greet Optional)"
                : ""
            } `}
          />

          <InfoCard
            b2b={b2b}
            color="text-yellow-700"
            fontawesomeIconName={faCheckCircle}
            infotext="Free cancellation upto 24 hour prior to time for both oneway transfer and hourly disposals."
          />
          <InfoCard
            b2b={b2b}
            color="text-green-600"
            fontawesomeIconName={faCheckCircle}
            infotext="Flight No./Train No. is mandatory for airport/station pickup and dropoff."
          />
          <InfoCard
            b2b={b2b}
            color="text-green-600"
            fontawesomeIconName={faCheckCircle}
            infotext="Guest/luggage capacities must be abided by for safety reasons. If you are unsure, select a larger class as chauffeurs may turn 
              down service when they are exceeded."
          />
          <InfoCard
            b2b={b2b}
            color="text-green-600"
            fontawesomeIconName={faCheckCircle}
            infotext="The vehicle images are just for reference, you may get a different vehicle of similar quality depending on destination."
          />
          <InfoCard
            b2b={b2b}
            color="text-green-600"
            fontawesomeIconName={faCheckCircle}
            infotext={`${
              companyPermission?.flatRateBooking?.MeetAndGreet === "WITHOUT"
                ? "Price includes tolls, taxes and gratuities"
                : "All prices include VAT, Gratuities, Meet and Greet services."
            } `}
          />
        </div>
      </div>
      <div className="xl:-mt-10 my-10">
        {/* car picture */}
        <div
          className={`${
            b2b
              ? "transform -translate-y-12 translate-x-4 sm:mt-10"
              : "transform -translate-y-6 translate-x-4"
          } `}
        >
          <img
            src={image}
            alt="car"
            className={
              b2b
                ? "w-72 lg:w-64 xl:w-72 h-full lg:bg-auto center"
                : "w-64 h-full transform"
            }
          />
        </div>
        <div
          className={
            b2b ? "sm:-translate-y-5 lg:translate-y-0" : "-translate-y-2 mt-3"
          }
        >
          {!isOffLine ? (
            <div className="flex items-center justify-center md:justify-center lg:justify-start xl:justify-start space-x-2 transform lg:translate-x-1/3">
              <span className="text-xl font-semibold text-secondary">
                {unit}
              </span>

              <span
                className={`${
                  b2b ? "text-2xl" : "text-4xl"
                }   text-primary font-semibold`}
              >
                {price === "Loading..." ? <LoadingIcon /> : price}
              </span>
            </div>
          ) : (
            <>
              <div className="flex items-center space-x-2 text-center ml-24">
                <div className="text-xl font-bold text-secondary">
                  {selectdCurrency}
                </div>
                <input
                  type="text"
                  placeholder="Add Price"
                  onChange={priceInputChange}
                  value={priceValue}
                  className=" text-xl font-bold w-28 text-primary"
                />
              </div>
            </>
          )}
          {user.permission?.newBooking?.MakeBooking?.permission ===
          "DISABLE" ? (
            <div>
              <div className="w-64 animate-pulse text-white bg-secondary px-3 py-2 rounded-md ">
                You don't have permission to make a booking
              </div>
            </div>
          ) : (
            <>
              {!bookingInitiateLoading ? (
                <div
                  onClick={onClick}
                  className={`bg-secondary hover:bg-gray-300 hover:text-black font-semibold cursor-pointer text-white ${
                    b2b ? "font-regular" : "font-semibold"
                  }  text-center py-1.5 md:px-5 ${
                    b2b ? "mx-5" : "mx-3"
                  }  rounded-md`}
                >
                  BOOK NOW
                </div>
              ) : (
                <div
                  className={`bg-secondary hover:bg-gray-300 hover:text-black font-semibold cursor-pointer text-white ${
                    b2b ? "font-regular" : "font-semibold"
                  }  text-center py-3 md:px-5 ${
                    b2b ? "mx-5" : "mx-3"
                  }  rounded-md`}
                >
                  <div className="flex space-x-2 items-center justify-center">
                    {/* <div className="font-thin">Loading...</div> */}
                    <LoadingIcon />
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        {/* price with button */}
      </div>
    </div>
  );
};
